import React from 'react';

const PressLogos = () => {
  const logos = [
    { name: "TechCrunch", textColor: "#1a8917" },
    { name: "New York Times", textColor: "#333" },
    { name: "USA Today", textColor: "#009bff" },
    { name: "Cosmopolitan", textColor: "#333" },
    { name: "Harper's Bazaar", textColor: "#333" }
  ];

  return (
    <section className="bg-gray-50 py-8 border-t border-b border-gray-100">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-center gap-8 md:gap-16 flex-wrap opacity-50">
          {logos.map((logo, idx) => (
            <span
              key={idx}
              className="text-gray-400 text-sm md:text-base font-bold tracking-wide uppercase"
              style={{ fontFamily: 'Georgia, serif' }}
            >
              {logo.name}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PressLogos;
